<!-- pc mobile 通用 -->
<script setup lang="ts">
import { useRoute } from '#imports'

const route = useRoute()

function goBackTop() {
  window.scrollTo({ behavior: 'smooth', top: 0 })
}
</script>

<!-- pc mobile 通用 -->
<template>
  <div class="footer-bg">
    <div class="footer">
      <NuxtLink to="/" class="logo-link" @click="goBackTop">
        <img src="/images/logo.png" class="logo" alt="logo" />
      </NuxtLink>
      <div v-if="false" class="qrcode-container">
        联系我们
        <img src="/images/qrcode.jpg" alt="qrcode" class="qrcode" />
        <div class="bottom">
          <div class="line"></div>
          微信公众号
          <div class="line"></div>
        </div>
      </div>
      <div class="text-line">
        <NuxtLink :class="{ link: true, active: route.name === 'about' }" to="/about" target="_blank">
          公司介绍
        </NuxtLink>
        &nbsp;|&nbsp;
        <NuxtLink
          :class="{ link: true, active: route.name === 'childrenProtocol' }"
          to="/childrenProtocol"
          target="_blank"
        >
          儿童隐私保护指引
        </NuxtLink>
        &nbsp;|&nbsp;
        <NuxtLink :class="{ link: true, active: route.name === 'userProtocol' }" to="/userProtocol" target="_blank">
          隐私政策
        </NuxtLink>
      </div>
      <div class="text-line">
        <a class="link" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2024074023号-1</a>
      </div>
      <div class="text-line">版权所有 © 2024-2025 杭州韵玟科技有限公司</div>
      <div class="text-line">浙江省杭州市拱墅区科西路102号二楼2118室</div>
      <div class="divider"></div>
      <div class="text-line">
        健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。
        <span class="text-line-desc">合理安排时间，享受健康生活。</span>
      </div>
      <div class="text-line">
        亲爱的市民朋友，浙江警方反诈劝阻电话“96110”系专门针对避免您财产被骗受损而设，请您一旦收到来电，立即接听。
      </div>
      <div class="text-line">违法和不良信息举报邮箱：youxi@yunwente.cn</div>
      <div class="text-line">
        <a class="link" href="https://jbts.mct.gov.cn/" target="_blank">全国文化市场统一举报电话：12318</a>
        |
        <a class="link" href="https://www.shdf.gov.cn/shdf/channels/740.html" target="_blank">扫黄打非举报</a>
      </div>
      <div class="gov-unit-container">
        <div class="gov-unit">互联网文化经营单位</div>
        <a href="https://www.12377.cn/" target="_blank" class="gov-unit link">网上有害信息举报专区</a>
        <a href="https://www.hangzhoujubao.com/" target="_blank" class="gov-unit link">
          杭州市互联网违法和不良信息举报中心
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.footer-bg {
  min-width: var(--pc-page-min-width);
  background-image: linear-gradient(333deg, #1c0b48 9.19%, #0e062c 53.3%, #0f1125 94.5%);
  padding: 90px 0;
  font-size: 18px;
  line-height: 20px;

  .footer {
    width: 1200px;
    margin: 0 auto;
    color: #c0c8df;
    position: relative;

    .qrcode-container {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      color: #ffffff;
      font-size: 18px;
      text-align: center;

      .qrcode {
        margin: 16px 0;
        display: block;
        width: 176px;
        height: 176px;
      }

      .bottom {
        display: flex;
        justify-content: space-around;
        align-items: center;

        .line {
          width: 28px;
          height: 1px;
          background: #ffffff;
        }
      }
    }

    .logo-link {
      width: 258px;
      display: block;
      margin-bottom: 44px;
    }

    .logo {
      width: 258px;
    }

    .link {
      color: #c0c8df;

      &:hover {
        color: #ffffff;
      }
    }

    .active {
      color: #ffffff;
    }

    .text-line {
      margin-bottom: 16px;
    }

    .divider {
      height: 1px;
      background-color: #c0c8df;
      margin: 44px 0;
      opacity: 0.25;
    }

    .gov-unit-container {
      display: flex;

      .gov-unit {
        display: flex;
        align-items: center;
        border-radius: 8px;
        background: transparent;
        margin-right: 8px;
      }
    }
  }
}

@media screen and (orientation: portrait) {
  .footer-bg {
    min-width: 375rem;
    height: auto;
    overflow: hidden;
    padding: 32rem 0;
    align-items: center;
    text-align: center;
    font-size: 12rem;
    line-height: 16rem;
    background-image: url('/images/mobileFooterBg.png');
    background-size: cover;

    .footer {
      width: 375rem;

      .qrcode-container {
        display: none;
      }

      .logo-link {
        width: 175rem;
        display: block;
        margin: 0 auto 24rem;
      }

      .logo {
        width: 175rem;
      }

      .text-line {
        margin: 0 20rem 13rem;

        .text-line-desc {
          display: block;
        }
      }

      .divider {
        height: 0.8rem;
        margin: 24rem 20rem;
      }

      .gov-unit-container {
        margin: 0 16rem;
        flex-wrap: wrap;
        justify-content: center;

        .gov-unit {
          line-height: 24rem;
        }
      }
    }
  }
}
</style>
